module.exports = __webpack_public_path__ + "static/media/background2.732924ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/background2.png
// module id = 42
// module chunks = 0